import React from 'react';
import Button from 'components/Button';
import imgPrint from 'images/print-24.svg';

const PrintButton = () =>
    <Button
        onClick={() => window.print()}
        className="print-button"
        type="icon"
        icon={imgPrint}
        theme="link"
    />
;

export default PrintButton;
